import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom"
import LearnerHome from "../LearnerHome/LearnerHome";
import PublicHome from "../PublicHome/PublicHome";

const HomePage = (props: any) => {
  const commonInfo = useSelector((state: any) => state.common);
  const allInfo = useSelector((state: any) => state);
  // if(!!!allInfo.learnerTasks.isLoading && !!allInfo.learnerTasks.data && !!!commonInfo.isLoading && !!commonInfo.isUserAuthenticated){
  //   console.log("HOMEPAGE", allInfo.learnerTasks , !!!commonInfo.isLoading && !!commonInfo.isUserAuthenticated) ;
  //   // <Redirect to="/somewhere/else" />
  // }  

  const isLearnerTaskCompleted = ()=>{
    let filteredResp;
    const respData = allInfo.learnerTasks.data.getLearnerTasks ? allInfo.learnerTasks.data.getLearnerTasks : [];
    if (respData.length > 0) {
      filteredResp = respData.filter((taskObj: any) => {
        return `${taskObj.taskid}` === "1";
      });
    }
    return (filteredResp && filteredResp.length > 0 && filteredResp[0].status);
  } 
  
  return (
  <div>
    {
      (!!!allInfo.learnerTasks.isLoading && !!allInfo.learnerTasks.data && !!!commonInfo.isLoading && !!commonInfo.isUserAuthenticated) ? (
        <div>
          {
            isLearnerTaskCompleted() ? <div className="HomePageContainer"><LearnerHome authProps={{...props}} isEnglishUser={props.isEnglishUser} /></div> : <Redirect to="/welcome" />
          }
        </div>                
      ) :
      (
          <div className="HomePageContainer"><PublicHome authProps={{...props}}/></div>
      )
    }
  </div>)
};

export default HomePage;
